import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRules } from '../rules/use-rules';
import { ruleTitles } from './rule-titles';

/** The rules view, loaded once for the overview, as a map section → title. */
export function useRuleTitles(): ReadonlyMap<string, string> {
  const { t } = useTranslation('archive');
  const { state } = useRules();
  return useMemo(
    () =>
      state.status === 'ready'
        ? ruleTitles(state.rules, {
            naming: t('rules.naming'),
            type: t('overview.ruleType'),
            code: t('overview.ruleCode'),
          })
        : new Map<string, string>(),
    [state, t],
  );
}
